/********************************************
* Primary navigation
********************************************/
function fnNavigationPrimary( i, oSection ) {

	var oBody 					= $( 'body' ),
		oHeader 				= $( oSection ),
		oDesktopMainMenu		= $( 'nav.main-menu', oHeader ),
		oMobileMainMenu			= $( 'aside.mobile-nav', oHeader ),
		oMenuTrigger			= $( '.menu-trigger', oHeader ),
		iWindowHeight			= $( window ).height();

	/*************************
	* Hide/show on scroll
	*************************/
	var iLastScrollTop 			= 0,
    	iMinScroll 				= 300,
    	iNavbarHeight 			= $( oHeader ).outerHeight();

    $( window ).scroll( function( event ) {

		var iViewToTop 			= $( this ).scrollTop(),
			iWindowToTop 		= $( window ).scrollTop();

		if ( iViewToTop >= iWindowHeight ) {
			oHeader.addClass( 'on-scroll' );
			oBody.addClass( 'on-scroll' );
		} else {
			oHeader.removeClass( 'on-scroll' );
			oBody.removeClass( 'on-scroll' );
        }

    });


    /***************
	* Navigation hover to reveal sub-menus (desktop)
	***************/
    oDesktopMainMenu.find( 'ul.menu > li' ).hover( function() {

		// Hover interactions
		$( this ).toggleClass( 'hover' );
        $( this ).siblings( 'li.current' ).toggleClass( 'disable-current' );

		// Add class to body if menu item has dropdown - to activate body overlay
		if ( $( this ).hasClass( 'has-children' ) ) {

			$( 'body' ).toggleClass( 'nav-dropdown-open' );

		}

    });


    /***************
	* Navigation open/close (mobile)
	***************/
    oMenuTrigger.on( 'click', function() {

        $( oBody ).toggleClass( 'nav-visible' );

    });


    /***************
	* Navigation sub-menus (mobile)
	***************/
    oMobileMainMenu.find( 'nav.product-menu li.has-children i.sub-arrow' ).on( 'click', function() {

		var oCurrentItem 		= $( this ).parent( 'li' ),
			oSiblingItem		= $( this ).parent( 'li' ).siblings( 'li.open' );

		oCurrentItem.toggleClass( 'open' );
		oSiblingItem.removeClass( 'open' );

		oCurrentItem.find( 'ul.sub-menu' ).slideToggle( 600 );
		oSiblingItem.find( 'ul.sub-menu' ).slideToggle( 600 );

    });

}



// END OF DOCUMENT
